module.exports = __webpack_public_path__ + "img/bactech2.5993e74b.png";